/* eslint-disable global-require */

const ICONS = {
  LOGO: require('./logo-icon.svg'),
  PLUS: require('./plus-icon.svg'),
  WATER: require('./water-icon.svg'),
  MONEY: require('./money-icon.svg'),
  DNI: require('./dni-icon.svg'),
  BELL: require('./bell-icon.svg'),
  CALENDAR: require('./calendar-icon.svg'),
  ARROW: require('./arrow-icon.svg'),
  CLOSE: require('./close-icon.svg'),
  RIGHT_ARROW: require('./right-arrow-icon.svg'),
  CHEVRON_LEFT: require('./chevron-left-icon.svg'),
  DARK_CHEVRON_LEFT: require('./dark-chevron-left-icon.svg'),
  MARKER: require('./marker-icon.svg'),
  WHITE_MARKER: require('./white-marker-icon.svg'),
  MASK: require('./mask-icon.svg'),
  GLASSES: require('./glasses-icon.svg'),
  SIMPLE_ARROW: require('./simple-arrow-icon.svg'),
  FB_ICON: require('./fb-icon.svg'),
  IG_ICON: require('./ig-icon.svg'),
  TW_ICON: require('./tw-icon.svg'),
  LIN_ICON: require('./lin-icon.svg'),
};

export default ICONS;
